import React, {useState} from 'react';
import {SubmissionDto, SubmissionApi, SubmissionAuditSupervisorResult} from '../../scaffold';
import {Alert, Button, Divider, Popconfirm, Radio, Space} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import {useInput} from 'react-hanger';
import Title from 'antd/lib/typography/Title';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import SubmissionPapers from './Papers';

export default function SubmissionSupervisorAudit(props: {submission: SubmissionDto; onSuccess: () => any}) {
  const remark = useInput('');
  const auditState = useOpenApiFpRequest(SubmissionApi, SubmissionApi.prototype.submissionAuditSupervisorPost);
  const abandonState = useOpenApiFpRequest(SubmissionApi, SubmissionApi.prototype.submissionAbandonSupervisorPost);
  const [result, setResult] = useState(SubmissionAuditSupervisorResult.通过);
  const des = {
    [SubmissionAuditSupervisorResult.通过]: '达到论文要求，作稍许修改后可以进入盲审阶段。',
    [SubmissionAuditSupervisorResult.需修改]: '论文存在一定问题，根据督导意见修改（一个月内完成）再次提交督导（提交时附上修改说明）',
    [SubmissionAuditSupervisorResult.不通过]: '论文存在较大缺陷，须作重大修改，延期半年后重新提交督导老师（提交时附上修改说明)',
  };
  function audit() {
    auditState
      .request({
        submissionAuditSupervisorModel: {
          id: props.submission.id || 0,
          result,
          remark: remark.value,
        },
      })
      .then(props.onSuccess)
      .catch(CommonApiErrorHandler);
  }
  function abandon() {
    abandonState
      .request({
        findParams: {
          id: props.submission.id || 0,
        },
      })
      .then(props.onSuccess)
      .catch(CommonApiErrorHandler);
  }
  const secondTime = !!props.submission.logs?.find(i => i.title === '督导审批');
  return (
    <div>
      <Alert type={'warning'} className={'m-b-15'} message={`本次为第 ${props.submission.superviseSubmitCount} 次提交`} />
      <Title level={3}>督导审核</Title>
      <SubmissionPapers submission={props.submission} isJudgeVersion={false} refresh={props.onSuccess} readonly />
      <Title className={'m-t-20'} level={4}>
        论文存在的主要问题
      </Title>
      <TextArea {...remark.eventBind} placeholder={'请输入论文存在的主要问题'} rows={3} />
      <Title className={'m-t-20'} level={4}>
        结论
      </Title>
      <Radio.Group value={result} onChange={e => setResult(e.target.value)}>
        <Radio value={SubmissionAuditSupervisorResult.通过}>{des[SubmissionAuditSupervisorResult.通过]}</Radio>
        {!secondTime && <Radio value={SubmissionAuditSupervisorResult.需修改}>{des[SubmissionAuditSupervisorResult.需修改]}</Radio>}
        <Radio value={SubmissionAuditSupervisorResult.不通过}>{des[SubmissionAuditSupervisorResult.不通过]}</Radio>
      </Radio.Group>
      <Space className={'m-t-20'}>
        <Popconfirm title={'确认完成审批吗'} onConfirm={audit}>
          <Button type={'primary'} loading={auditState.loading}>
            完成审批
          </Button>
        </Popconfirm>
        <Popconfirm title={'确认请求更换督导吗'} onConfirm={abandon}>
          <Button loading={abandonState.loading}>放弃本次审核，请求更换督导</Button>
        </Popconfirm>
      </Space>
      <Divider />
    </div>
  );
}
